"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { OffreData } from "@/db/schema/content-items";

// Contexte partagé par tous les contrôles d'admin rendus sur `/[slug]`
// (boutons flottants de régénération, sidebar). `data` vient à chaque rendu
// des props du Server Component `page.tsx` — pas de miroir en state local ici :
// après un `router.refresh()`, la nouvelle valeur de `data` redescend telle
// quelle via ce contexte, sans risque de désynchronisation.
export interface AdminOverlayValue {
  itemId: string;
  slug: string;
  publicUrl: string;
  data: OffreData;
}

const AdminOverlayContext = createContext<AdminOverlayValue | null>(null);

export function AdminOverlayProvider({
  value,
  children,
}: {
  value: AdminOverlayValue;
  children: ReactNode;
}) {
  return <AdminOverlayContext.Provider value={value}>{children}</AdminOverlayContext.Provider>;
}

export function useAdminOverlay(): AdminOverlayValue {
  const ctx = useContext(AdminOverlayContext);
  if (!ctx) {
    throw new Error("useAdminOverlay doit être utilisé sous AdminOverlayProvider");
  }
  return ctx;
}
